export default "/assets/1927e3fe3919c6eb0db9b53afda16153.png";